var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('a-tabs',{attrs:{"activeKey":_vm.activeKey},on:{"change":_vm.handleTabClick}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"未关闭"}},[_c('question-list',{attrs:{"status":'1'}})],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"已关闭"}},[_c('question-list',{attrs:{"status":'2'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }